import { useMemo } from 'react';

import { getBuilderBlockDetailMeta, getBuilderBlockDetailTable } from './builderBlockDetailStore';
import { mergeArrowVirtualDimTableData } from './mergeArrowVirtualDimTableData';

type UseBuilderArrowVirtualTableDataArguments = {
  enabled: boolean;
  indicatorValues: any[] | null | undefined;
  expandedParentIds: ReadonlySet<number>;
  blockId: string | undefined;
  scenarioId: number | undefined;
  /** Bump when Arrow windows or expand set changes so merge re-runs. */
  revision: number;
};

/**
 * Parents from Redux + Arrow virtual dim rows/spacers for expanded chevrons (render-time only).
 */
export default function useBuilderArrowVirtualTableData({
  enabled,
  indicatorValues,
  expandedParentIds,
  blockId,
  scenarioId,
  revision,
}: UseBuilderArrowVirtualTableDataArguments): any[] {
  return useMemo(() => {
    if (!enabled || !blockId || !scenarioId) {
      return indicatorValues ?? [];
    }

    if (expandedParentIds.size === 0) {
      return indicatorValues ?? [];
    }

    const parentsOnly = (indicatorValues ?? []).filter(
      (row) => row?.chevronType !== 'child' && row?.chevronType !== 'arrow-spacer',
    );

    const detailTable = getBuilderBlockDetailTable(blockId, scenarioId);
    const detailMeta = getBuilderBlockDetailMeta(blockId, scenarioId);

    return mergeArrowVirtualDimTableData(parentsOnly, expandedParentIds, detailTable, detailMeta);
  }, [enabled, indicatorValues, expandedParentIds, blockId, scenarioId, revision]);
}
